 
export const Order = Object.freeze({
    Ascending: 0,
    Descending: 1,
});
